// @flow
import { system, type Config } from 'styled-system';
import type { TextTransform } from '@rover/design-system/style-dictionary/build/es6/theme';
import { createTransformWithDefault } from './transforms';

export type TextTransformProps = {|
  textTransform?: TextTransform,
|};

const config: Config<TextTransformProps> = {
  textTransform: {
    property: 'textTransform',
    scale: 'textTransform',
    transform: createTransformWithDefault('none'),
  },
};

export default system<TextTransformProps>(config);



// WEBPACK FOOTER //
// ../react-lib/src/styles/styled-system/textTransform.js